import FontAwesome from '@vromo/ui/components/FontAwesome';
import Tooltip from '@vromo/ui/components/Tooltip';
import theme from '@vromo/ui/components/theme';
import React from 'react';

const BetaTag = () => (
    <Tooltip
        position="bottom"
        label="You can switch back to the old view from the Account Settings page.">
        <div>
            <div
                style={{
                    position: 'relative',
                    marginLeft: 12,
                    height: 16,
                    borderRadius: 8,
                    padding: '2px 6px',
                    backgroundColor: theme.primary,
                    color: 'white',
                    fontSize: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                BETA
                <div
                    style={{
                        position: 'absolute',
                        backgroundColor: 'black',
                        borderRadius: 10,
                        width: 8,
                        height: 8,
                        padding: 0,
                        left: -4,
                        top: -2
                    }}>
                    <FontAwesome
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: -1,
                            right: 0,
                            bottom: 0
                        }}
                        icon="info-circle"
                    />
                </div>
            </div>
        </div>
    </Tooltip>
);

export default BetaTag;
